export const DOCUMENT_TYPE_SUBCATEGORY = 'commerce.subcategory';
